import { post } from 'axios';

export const validateCaptcha = async (endpoint, captcha, formName, formFields) => {
    try{
        const response = await post(endpoint, {
            headers: {'Content-Type': 'application/json'},
            captcha,
            [formName]: formFields,
        });   
        // if response status is not 200, move to catch block
        if(response.status !== 200) {
            throw new ApiHttpError(response);
        }

        return response.data;
    
    }catch({ response }) {
        return {
            status: (response.status) ? response.status : 500,
            message: (response.data && response.data.message) ? response.data.message : 'Something went wrong. Please try again.'
        };
    }
};


class ApiHttpError extends Error {
    constructor(response = { status: 500 }, ...params) {
        super(...params);

        this.response = response;
    }
}